/**
 * Initialize Google Analytics(GA) 
 */
export const initGA = () => {
    // All the hyperlinks
    const hrefs = document.querySelectorAll('a');

    // Check all links
    hrefs.forEach(href => {

        // Append Click events if ID is presented
        if (href.id) {
            href.addEventListener('click', onExit);
            href.hasGATracking = true;
        }
    })
};





/**
 * Exit Event Tracking for GA
 * @param {MouseEvent} e 
 */
const onExit = e => {
    // check for global ga object
    let gtag = window.gtag;
    // console.log(e.currentTarget.id)
    if (gtag && e.currentTarget.id) {
        gtag('event', 'click', {
            'event_category': 'Exit',
            'event_label': e.currentTarget.id,
            'value': e.currentTarget.href
        });

    }
}

